import { render, staticRenderFns } from "./sent_email.vue?vue&type=template&id=73b89b91&"
import script from "./sent_email.vue?vue&type=script&lang=js&"
export * from "./sent_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports